function submitWbWorkDeactivate(button) {
  const url = button.dataset.deactivateUrl;
  const redirectRoute = button.dataset.redirectRoute;
  const tokenKey = button.dataset.tokenKey;
  const tokenValue = button.dataset.tokenValue;

  if (!url || !redirectRoute || !tokenKey || !tokenValue) {
    return;
  }

  const form = document.createElement('form');
  form.method = 'post';
  form.action = url;
  form.style.display = 'none';

  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = tokenKey;
  csrfInput.value = tokenValue;
  form.appendChild(csrfInput);

  const redirectInput = document.createElement('input');
  redirectInput.type = 'hidden';
  redirectInput.name = 'work_deactivate_redirect';
  redirectInput.value = redirectRoute;
  form.appendChild(redirectInput);

  document.body.appendChild(form);
  form.submit();
}

export default function initWbWorkDeactivate() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-wb-work-deactivate-btn');

    if (!button || button.disabled) {
      return;
    }

    event.preventDefault();
    button.disabled = true;
    submitWbWorkDeactivate(button);
  });
}
